import React from 'react';
import './index.scss';
import StationIcon from '@/assets/images/station-icon.png';
import LoadIcon from '@/assets/images/jkc/createTask/load-icon.png';
import UnloadIcon from '@/assets/images/jkc/createTask/unload-icon.png';
import RightIcon from '@/assets/images/right-icon.png';
import { CloseOutline } from 'antd-mobile-icons';
import { showErrorToast } from '@/utils/toast';
import { JKCContact } from '@/jkc/utils/type';

interface IProps {
  stopName?: string;
  contactList: any[];
  placeholder: string;
  onSelectStop: () => void;
  onAddContact: () => void;
  onDeleteContact: (contact: JKCContact) => void;
  type?: 'load' | 'unload';
}

const SelectStop: React.FC<IProps> = ({
  stopName,
  contactList,
  placeholder,
  onSelectStop,
  onAddContact,
  onDeleteContact,
  type
}) => {
  const otherClass = stopName ? 'has-stop-name' : '';
  const iconSrc =
    type === 'load' ? LoadIcon : type === 'unload' ? UnloadIcon : StationIcon;

  return (
    <div className="select-stop-jkc">
      <img className="select-stop-jkc-icon" src={iconSrc} alt="icon" />
      <div className={`select-stop-jkc-content ${otherClass}`}>
        <div className={`select-stop-jkc-item-stop `} onClick={onSelectStop}>
          {stopName || placeholder}
        </div>
        <div className="select-stop-jkc-divider"></div>
        <div className="select-stop-jkc-item-contact">
          {contactList?.length < 5 && (
            <span onClick={onAddContact}>
              添加联系人
              <img src={RightIcon} />
            </span>
          )}
          {contactList &&
            contactList?.length > 0 &&
            contactList.map((v: any) => (
              <span className="selected-user" key={v.userPhone}>
                {`${v.userName} ${v.userPhone}`}
                <CloseOutline onClick={() => onDeleteContact(v)} />
              </span>
            ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(SelectStop);
